/**
 * MUSKLE goal-page share — Web Share API with clipboard fallback.
 * Idempotent: safe if included more than once.
 * Status copy comes from data-goal-share-* attributes on the section (locale keys).
 */
(function () {
  if (window.__muskleGoalShareInit) return;
  window.__muskleGoalShareInit = true;

  function setStatus(el, text) {
    if (el) el.textContent = text || '';
  }

  function copyFrom(section, key, fallback) {
    if (!section) return fallback;
    return section.getAttribute(key) || fallback;
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-goal-share]');
    if (!button) return;

    var title = button.getAttribute('data-share-title') || document.title;
    var url = button.getAttribute('data-share-url') || window.location.href;
    var section = button.closest('.muskle-goal-share');
    var status = section ? section.querySelector('[data-goal-share-status]') : null;
    var msgShared = copyFrom(section, 'data-goal-share-shared', 'Page shared.');
    var msgCopied = copyFrom(section, 'data-goal-share-copied', 'Link copied.');
    var msgFallback = copyFrom(section, 'data-goal-share-copy-fallback', 'Copy this link:');

    try {
      if (navigator.share) {
        await navigator.share({ title: title, url: url });
        setStatus(status, msgShared);
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
        setStatus(status, msgCopied);
        return;
      }

      setStatus(status, msgFallback + ' ' + url);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      setStatus(status, msgFallback + ' ' + url);
    }
  });
})();
